export function getBaseUrl() {
    const currentHost = window.location.host;
    // console.log('currentHost')
    // console.log(currentHost)
    if (currentHost.includes("econopro.app")) {
        const currentHostTrat = 'https://' + currentHost.replace("econopro.app", "econocargo.net") + '/'
        // console.log('currentHostTrat')
        // console.log(currentHostTrat)
        return currentHostTrat
    } else {
        const url = process.env.VUE_APP_URL || '';
        return url.endsWith('/') ? url : url + '/';
    }
}